/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

export const NOTIFICATION_NUMBER = "NOTIFICATION_NUMBER";
export const ONESIGNAL_SUBSCRIPTION = "ONESIGNAL_SUBSCRIPTION";
export const DOCTOR_ONLINE_DATA = "DOCTOR_ONLINE_DATA";
export const DOCTOR_ONLINE_STATE = "DOCTOR_ONLINE_STATE";
export const DOCTOR_APPOINTMENT_DATA = "DOCTOR_APPOINTMENT_DATA";
export const VIDEO_CALL_DATA = "VIDEO_CALL_DATA";
export const SESSION_ID = "SESSION_ID";
export const IS_TIMER_TIMEOUT = "IS_TIMER_TIMEOUT";
export const SET_FORUM_READ_TOPICS = "SET_FORUM_READ_TOPICS";
export const SET_FORUM_READ_COMMENTS = "SET_FORUM_READ_COMMENTS";
export const SET_ONLINE_ASSESSMENT_START_STATUS = "SET_ONLINE_ASSESSMENT_START_STATUS";
export const SET_USER_ACCESS = "SET_USER_ACCESS";
export const CONSTANTS = "CONSTANTS";
export const TOTAL_DOCTORS = "TOTAL_DOCTORS";
export const PATIENT_QUEUE_COUNT_DATA = "PATIENT_QUEUE_COUNT_DATA";
